// extracted by mini-css-extract-plugin
module.exports = {"root":"ErrorsBlock_root__3K7gv"};